var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "evaluation-stat-v3" },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _vm.displayData
          ? _c("div", { staticClass: "header-badge-group" }, [
              _c("span", { staticClass: "live-indicator" }, [
                _c("span", { staticClass: "pulse-dot" }),
                _vm._v(
                  "\n        Đã nhận xét: " +
                    _vm._s(_vm.currentStats.reviewedCount) +
                    "/" +
                    _vm._s(_vm.currentStats.totalStudents) +
                    " học sinh (" +
                    _vm._s(_vm.currentStats.rate) +
                    "%)\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        {
          staticClass: "evaluation-type-switcher",
          attrs: { role: "group", "aria-label": "Loại nhận xét" },
        },
        [
          _c("span", { staticClass: "evaluation-type-label" }, [
            _vm._v("Loại nhận xét:"),
          ]),
          _c(
            "div",
            { staticClass: "evaluation-type-options" },
            _vm._l(_vm.evaluationTypes, function (item) {
              return _c(
                "button",
                {
                  key: item.value,
                  class: [
                    "evaluation-type-button",
                    { active: _vm.selectedEvaluationType === item.value },
                  ],
                  attrs: {
                    type: "button",
                    "aria-pressed": _vm.selectedEvaluationType === item.value,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeEvaluationType(item.value)
                    },
                  },
                },
                [_vm._v(_vm._s(item.label))]
              )
            }),
            0
          ),
        ]
      ),
      _vm.selectedEvaluationType === "DAILY"
        ? _c("div", { staticClass: "filter-control-bar" }, [
            _c(
              "div",
              { staticClass: "filter-left" },
              [
                _c(
                  "div",
                  { staticClass: "filter-chip" },
                  [
                    _vm._m(1),
                    _c(
                      "el-select",
                      {
                        staticClass: "filter-select",
                        attrs: {
                          size: "small",
                          placeholder: "Tất cả các khối",
                        },
                        on: { change: _vm.handleGradeChange },
                        model: {
                          value: _vm.filterGrade,
                          callback: function ($$v) {
                            _vm.filterGrade = $$v
                          },
                          expression: "filterGrade",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: "Toàn trường (Tất cả các khối)",
                            value: "",
                          },
                        }),
                        _vm._l(_vm.availableGradeOptions, function (item) {
                          return _c("el-option", {
                            key: item.gradeId,
                            attrs: {
                              label: item.gradeName,
                              value: item.gradeId,
                            },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "filter-chip" },
                  [
                    _vm._m(2),
                    _c(
                      "el-select",
                      {
                        staticClass: "filter-select",
                        attrs: { size: "small", placeholder: "Tất cả các lớp" },
                        on: { change: _vm.handleClassChange },
                        model: {
                          value: _vm.filterClass,
                          callback: function ($$v) {
                            _vm.filterClass = $$v
                          },
                          expression: "filterClass",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "Tất cả các lớp", value: "" },
                        }),
                        _vm._l(_vm.filteredClassOptions, function (cls) {
                          return _c("el-option", {
                            key: cls.classId,
                            attrs: { label: cls.className, value: cls.classId },
                          })
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "filter-chip" },
                  [
                    _vm._m(3),
                    _c("el-date-picker", {
                      staticClass: "filter-date-picker",
                      attrs: {
                        type: "date",
                        size: "small",
                        placeholder: "Chọn ngày",
                        format: "dd/MM/yyyy",
                        "value-format": "yyyy-MM-dd",
                        clearable: false,
                        "picker-options": _vm.datePickerOptions,
                      },
                      on: { change: _vm.handleDateChange },
                      model: {
                        value: _vm.selectedDate,
                        callback: function ($$v) {
                          _vm.selectedDate = $$v
                        },
                        expression: "selectedDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm.filterGrade || _vm.filterClass
                  ? _c(
                      "el-button",
                      {
                        staticClass: "reset-scope-btn",
                        attrs: {
                          type: "text",
                          icon: "el-icon-refresh-left",
                          size: "small",
                        },
                        on: { click: _vm.resetFilterScope },
                      },
                      [_vm._v("\n        Xem toàn trường\n      ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "filter-right" }, [
              _vm._m(4),
              _c(
                "div",
                { staticClass: "period-button-group" },
                _vm._l(_vm.periodOptions, function (period) {
                  return _c(
                    "button",
                    {
                      key: period.value,
                      class: [
                        "p-btn",
                        { active: _vm.selectedPeriod === period.value },
                      ],
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.changePeriod(period.value)
                        },
                      },
                    },
                    [_vm._v(_vm._s(period.label))]
                  )
                }),
                0
              ),
            ]),
          ])
        : [
            _c("div", { staticClass: "filter-control-bar" }, [
              _c(
                "div",
                { staticClass: "filter-left" },
                [
                  _c(
                    "div",
                    { staticClass: "filter-chip" },
                    [
                      _vm._m(5),
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-select",
                          attrs: { size: "small" },
                          on: { change: _vm.handleGradeChange },
                          model: {
                            value: _vm.filterGrade,
                            callback: function ($$v) {
                              _vm.filterGrade = $$v
                            },
                            expression: "filterGrade",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "Toàn trường (Tất cả các khối)",
                              value: "",
                            },
                          }),
                          _vm._l(_vm.availableGradeOptions, function (item) {
                            return _c("el-option", {
                              key: item.gradeId,
                              attrs: {
                                label: item.gradeName,
                                value: item.gradeId,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "filter-chip" },
                    [
                      _vm._m(6),
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-select",
                          attrs: { size: "small" },
                          on: { change: _vm.handleClassChange },
                          model: {
                            value: _vm.filterClass,
                            callback: function ($$v) {
                              _vm.filterClass = $$v
                            },
                            expression: "filterClass",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "Tất cả các lớp", value: "" },
                          }),
                          _vm._l(_vm.filteredClassOptions, function (cls) {
                            return _c("el-option", {
                              key: cls.classId,
                              attrs: {
                                label: cls.className,
                                value: cls.classId,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm.selectedEvaluationType === "WEEKLY"
                    ? _c(
                        "div",
                        { staticClass: "filter-chip" },
                        [
                          _vm._m(7),
                          _c("el-date-picker", {
                            staticClass: "filter-date-picker",
                            attrs: {
                              type: "week",
                              size: "small",
                              format: "Tuần WW/yyyy",
                              placeholder: "Chọn tuần",
                              "picker-options": _vm.datePickerOptions,
                              clearable: false,
                            },
                            on: { change: _vm.loadPeriod },
                            model: {
                              value: _vm.selectedWeekDate,
                              callback: function ($$v) {
                                _vm.selectedWeekDate = $$v
                              },
                              expression: "selectedWeekDate",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm.selectedEvaluationType === "MONTHLY"
                    ? _c(
                        "div",
                        { staticClass: "filter-chip" },
                        [
                          _vm._m(8),
                          _c("el-date-picker", {
                            staticClass: "filter-date-picker",
                            attrs: {
                              type: "month",
                              size: "small",
                              format: "MM/yyyy",
                              "value-format": "yyyy-MM",
                              placeholder: "Chọn tháng",
                              "picker-options": _vm.datePickerOptions,
                              clearable: false,
                            },
                            on: { change: _vm.loadPeriod },
                            model: {
                              value: _vm.selectedMonth,
                              callback: function ($$v) {
                                _vm.selectedMonth = $$v
                              },
                              expression: "selectedMonth",
                            },
                          }),
                        ],
                        1
                      )
                    : [
                        _c(
                          "div",
                          { staticClass: "filter-chip" },
                          [
                            _vm._m(9),
                            _c("el-date-picker", {
                              staticClass: "filter-date-picker",
                              attrs: {
                                type: "year",
                                size: "small",
                                format: "yyyy",
                                "value-format": "yyyy",
                                placeholder: "Chọn năm",
                                "picker-options": _vm.datePickerOptions,
                                clearable: false,
                              },
                              on: { change: _vm.handleYearChange },
                              model: {
                                value: _vm.selectedYear,
                                callback: function ($$v) {
                                  _vm.selectedYear = $$v
                                },
                                expression: "selectedYear",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "filter-chip" },
                          [
                            _vm._m(10),
                            _c("el-input-number", {
                              staticClass: "filter-number-picker",
                              attrs: {
                                size: "small",
                                min: 1,
                                max: 99,
                                controls: true,
                              },
                              on: { change: _vm.loadPeriod },
                              model: {
                                value: _vm.selectedPeriodNumber,
                                callback: function ($$v) {
                                  _vm.selectedPeriodNumber = $$v
                                },
                                expression: "selectedPeriodNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "filter-chip" },
                          [
                            _vm._m(11),
                            _c("el-date-picker", {
                              staticClass: "filter-date-picker",
                              attrs: {
                                type: "date",
                                size: "small",
                                format: "dd/MM/yyyy",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "Chọn ngày",
                                "picker-options": _vm.periodicDatePickerOptions,
                                clearable: false,
                              },
                              on: { change: _vm.loadPeriod },
                              model: {
                                value: _vm.selectedAnchorDate,
                                callback: function ($$v) {
                                  _vm.selectedAnchorDate = $$v
                                },
                                expression: "selectedAnchorDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                  _vm.filterGrade || _vm.filterClass
                    ? _c(
                        "el-button",
                        {
                          staticClass: "reset-scope-btn",
                          attrs: {
                            type: "text",
                            icon: "el-icon-refresh-left",
                            size: "small",
                          },
                          on: { click: _vm.resetFilterScope },
                        },
                        [_vm._v("Xem toàn trường")]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ],
      _vm.error
        ? _c("el-alert", {
            attrs: {
              title: _vm.error,
              type: "error",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _vm.loading
        ? _c("div", { staticClass: "evaluation-data-state" }, [
            _vm._v(
              "Đang tải thống kê " +
                _vm._s(_vm.selectedEvaluationLabel.toLowerCase()) +
                "..."
            ),
          ])
        : _vm._e(),
      _vm.displayData
        ? _c("div", { staticClass: "eval-kpi-grid" }, [
            _c("div", { staticClass: "eval-kpi-card border-indigo" }, [
              _vm._m(12),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Học sinh cần nhận xét"),
                ]),
                _c("div", { staticClass: "kpi-number text-indigo" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.currentStats.totalStudents) +
                      " "
                  ),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("học sinh")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(_vm._s(_vm.filterScopeLabel)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "eval-kpi-card border-emerald" }, [
              _vm._m(13),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Đã nhận xét"),
                ]),
                _c("div", { staticClass: "kpi-number text-emerald" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.currentStats.reviewedCount) +
                      " "
                  ),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("học sinh")]),
                ]),
                _c("div", { staticClass: "kpi-hint text-emerald" }, [
                  _c("i", { staticClass: "el-icon-top" }),
                  _vm._v(
                    " Đạt " +
                      _vm._s(_vm.currentStats.rate) +
                      "% hoàn thành\n        "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "eval-kpi-card border-rose" }, [
              _vm._m(14),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Chưa nhận xét"),
                ]),
                _c("div", { staticClass: "kpi-number text-rose" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.currentStats.unreviewedCount) +
                      " "
                  ),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("học sinh")]),
                ]),
                _c("div", { staticClass: "kpi-hint text-rose" }, [
                  _c("i", { staticClass: "el-icon-bell" }),
                  _vm._v(
                    " Còn " +
                      _vm._s(_vm.currentStats.unreviewedRate) +
                      "% chưa làm\n        "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "eval-kpi-card border-purple" }, [
              _vm._m(15),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Phụ huynh đã đọc"),
                ]),
                _c("div", { staticClass: "kpi-number text-purple" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.currentStats.parentReadCount) +
                      " "
                  ),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("học sinh")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(
                    "\n          Tỷ lệ đã đọc: " +
                      _vm._s(_vm.currentStats.parentReadRate) +
                      "% nhận xét đã duyệt\n        "
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.displayData
        ? _c(
            "el-row",
            { staticClass: "charts-row", attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 7 } }, [
                _c("div", { staticClass: "chart-card h-100" }, [
                  _c("div", { staticClass: "chart-card-head" }, [
                    _c("div", [
                      _c("h3", { staticClass: "chart-title" }, [
                        _vm._v("Tỷ Lệ Nhận Xét Chung"),
                      ]),
                      _c("p", { staticClass: "chart-subtitle" }, [
                        _vm._v(
                          _vm._s(_vm.currentPeriodTitle) +
                            " • " +
                            _vm._s(_vm.filterScopeLabel)
                        ),
                      ]),
                    ]),
                    _c(
                      "span",
                      {
                        class: [
                          "tag-pill",
                          _vm.currentStats.rate >= 90
                            ? "tag-pill--emerald"
                            : "tag-pill--amber",
                        ],
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.currentStats.rate >= 90
                                ? "Tiến độ tốt"
                                : "Cần đẩy nhanh"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", {
                    ref: "chartCompletionGauge",
                    staticClass: "chart-container",
                  }),
                  _c("div", { staticClass: "gauge-footer-grid" }, [
                    _c("div", { staticClass: "mini-stat-card" }, [
                      _c("span", { staticClass: "ms-label" }, [
                        _vm._v("Cần nhận xét"),
                      ]),
                      _c("strong", { staticClass: "ms-val text-indigo" }, [
                        _vm._v(_vm._s(_vm.currentStats.totalStudents)),
                      ]),
                    ]),
                    _c("div", { staticClass: "mini-stat-card" }, [
                      _c("span", { staticClass: "ms-label" }, [
                        _vm._v("Đã nhận xét"),
                      ]),
                      _c("strong", { staticClass: "ms-val text-emerald" }, [
                        _vm._v(_vm._s(_vm.currentStats.reviewedCount)),
                      ]),
                    ]),
                    _c("div", { staticClass: "mini-stat-card" }, [
                      _c("span", { staticClass: "ms-label" }, [
                        _vm._v("Chưa nhận xét"),
                      ]),
                      _c("strong", { staticClass: "ms-val text-rose" }, [
                        _vm._v(_vm._s(_vm.currentStats.unreviewedCount)),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 16, lg: 17 } }, [
                _c("div", { staticClass: "chart-card h-100" }, [
                  _c("div", { staticClass: "chart-card-head" }, [
                    _c("div", [
                      _c("h3", { staticClass: "chart-title" }, [
                        _vm._v("Tỷ Lệ Nhận Xét Từng Lớp So Với Khối / Trường"),
                      ]),
                      _c("p", { staticClass: "chart-subtitle" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.currentPeriodTitle) +
                            " • So sánh tỷ lệ % hoàn thành nhận xét giữa các lớp\n            "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "chart-action-group" }, [
                      _vm.displayedClassCount > 6
                        ? _c("span", { staticClass: "scroll-hint-chip" }, [
                            _c("i", { staticClass: "el-icon-sort" }),
                            _vm._v(
                              " Cuộn chuột dọc để xem đủ " +
                                _vm._s(_vm.displayedClassCount) +
                                " lớp\n            "
                            ),
                          ])
                        : _vm._e(),
                      _c("span", { staticClass: "benchmark-badge" }, [
                        _c("i", { staticClass: "el-icon-data-line" }),
                        _vm._v(" Trung bình: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.averageBenchmarkRate) + "%"),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", {
                    ref: "chartClassComparison",
                    staticClass: "chart-container-large",
                  }),
                  _c("div", { staticClass: "comparison-legend-row" }, [
                    _c("div", { staticClass: "legend-chip" }, [
                      _c("span", { staticClass: "chip-color chip-success" }),
                      _c("span", [_vm._v("Đạt chỉ tiêu (≥ 90%)")]),
                    ]),
                    _c("div", { staticClass: "legend-chip" }, [
                      _c("span", { staticClass: "chip-color chip-warning" }),
                      _c("span", [_vm._v("Đang tiến hành (75% - 89%)")]),
                    ]),
                    _c("div", { staticClass: "legend-chip" }, [
                      _c("span", { staticClass: "chip-color chip-danger" }),
                      _c("span", [_vm._v("Chậm tiến độ (< 75%)")]),
                    ]),
                    _c("div", { staticClass: "legend-chip" }, [
                      _c("span", { staticClass: "chip-line-benchmark" }),
                      _c("span", [
                        _vm._v(
                          "Mức trung bình (" +
                            _vm._s(_vm.averageBenchmarkRate) +
                            "%)"
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.displayData
        ? _c(
            "div",
            { staticClass: "class-progress-table-card" },
            [
              _c(
                "div",
                {
                  class: [
                    "table-card-head",
                    { "is-expanded": _vm.showClassTable },
                  ],
                },
                [
                  _c("div", { staticClass: "head-left" }, [
                    _vm._m(16),
                    _c("span", { staticClass: "table-card-subtitle" }, [
                      _vm._v(
                        _vm._s(_vm.currentPeriodTitle) +
                          " • Hiển thị " +
                          _vm._s(_vm.displayedClassList.length) +
                          " lớp"
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "head-right",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "10px",
                      },
                    },
                    [
                      _c("span", { staticClass: "table-count-badge" }, [
                        _vm._v(
                          "Tổng " +
                            _vm._s(_vm.displayedClassList.length) +
                            " lớp"
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          staticClass: "table-toggle-btn",
                          attrs: { size: "small", type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              _vm.showClassTable = !_vm.showClassTable
                            },
                          },
                        },
                        [
                          _c("i", {
                            class: _vm.showClassTable
                              ? "el-icon-arrow-up"
                              : "el-icon-arrow-down",
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.showClassTable
                                  ? "Thu gọn bảng"
                                  : "Xem chi tiết bảng"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showClassTable,
                        expression: "showClassTable",
                      },
                    ],
                    staticClass: "table-responsive-wrap",
                  },
                  [
                    _c("table", { staticClass: "modern-progress-table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticStyle: { width: "50px" } }, [
                            _vm._v("STT"),
                          ]),
                          _c("th", [_vm._v("Tên Lớp")]),
                          _c("th", [_vm._v("Khối")]),
                          _c("th", [_vm._v("Giáo viên hiện phụ trách")]),
                          _c(
                            "th",
                            {
                              staticClass: "text-center",
                              staticStyle: { width: "110px" },
                            },
                            [_vm._v("Cần NX")]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "text-center",
                              staticStyle: { width: "110px" },
                            },
                            [_vm._v("Đã NX")]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "text-center",
                              staticStyle: { width: "110px" },
                            },
                            [_vm._v("Chưa NX")]
                          ),
                          _c("th", { staticStyle: { width: "220px" } }, [
                            _vm._v("Tiến độ hoàn thành"),
                          ]),
                          _c(
                            "th",
                            {
                              staticClass: "text-center",
                              staticStyle: { width: "130px" },
                            },
                            [_vm._v("Trạng thái")]
                          ),
                        ]),
                      ]),
                      _c(
                        "tbody",
                        [
                          _vm.displayedClassList.length === 0
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    attrs: { colspan: "9" },
                                  },
                                  [_vm._v("Không có lớp trong phạm vi đã chọn")]
                                ),
                              ])
                            : _vm._e(),
                          _vm._l(_vm.displayedClassList, function (item, idx) {
                            return _c(
                              "tr",
                              {
                                key: item.classId,
                                class: {
                                  "row-highlight":
                                    _vm.filterClass === item.classId,
                                },
                              },
                              [
                                _c(
                                  "td",
                                  { staticClass: "text-center font-mono" },
                                  [_vm._v(_vm._s(idx + 1))]
                                ),
                                _c("td", [
                                  _c(
                                    "div",
                                    { staticClass: "class-name-cell" },
                                    [
                                      _c("strong", [
                                        _vm._v(_vm._s(item.className)),
                                      ]),
                                      _vm.filterClass === item.classId
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "badge-active-class",
                                            },
                                            [_vm._v("Đang xem")]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _c("td", [
                                  _c("span", { staticClass: "grade-pill" }, [
                                    _vm._v(_vm._s(item.gradeName)),
                                  ]),
                                ]),
                                _c("td", { staticClass: "text-secondary" }, [
                                  _vm._v(_vm._s(item.teachers)),
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-center font-semibold text-indigo",
                                  },
                                  [_vm._v(_vm._s(item.total))]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-center font-semibold text-emerald",
                                  },
                                  [_vm._v(_vm._s(item.reviewed))]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass:
                                      "text-center font-semibold text-rose",
                                  },
                                  [_vm._v(_vm._s(item.unreviewed))]
                                ),
                                _c("td", [
                                  _c(
                                    "div",
                                    { staticClass: "progress-bar-wrap" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "progress-track" },
                                        [
                                          _c("div", {
                                            staticClass: "progress-fill",
                                            class: _vm.getProgressColorClass(
                                              item.rate
                                            ),
                                            style: { width: item.rate + "%" },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "progress-rate-text font-semibold",
                                        },
                                        [_vm._v(_vm._s(item.rate) + "%")]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("td", { staticClass: "text-center" }, [
                                  _c(
                                    "span",
                                    {
                                      class: [
                                        "status-badge",
                                        _vm.getStatusBadgeClass(item.rate),
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.getStatusBadgeLabel(item.rate)
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-group" }, [
      _c("div", { staticClass: "header-icon-badge" }, [
        _c("i", { staticClass: "el-icon-chat-line-round" }),
      ]),
      _c("div", [
        _c("h2", { staticClass: "header-title" }, [
          _vm._v("Thống Kê Nhận Xét & Đánh Giá Học Sinh"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _vm._v(
            "Theo dõi tiến độ nhận xét học sinh theo lớp, khối và toàn trường"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-collection-tag" }),
      _vm._v(" Khối:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-s-home" }),
      _vm._v(" Lớp:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-time" }),
      _vm._v(" Ngày mốc:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "period-label" }, [
      _c("i", { staticClass: "el-icon-date" }),
      _vm._v(" Phạm vi thống kê:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-collection-tag" }),
      _vm._v(" Khối:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-s-home" }),
      _vm._v(" Lớp:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-date" }),
      _vm._v(" Tuần:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-date" }),
      _vm._v(" Tháng:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-date" }),
      _vm._v(" Năm dương lịch:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _vm._v(" Đợt đánh giá:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "chip-label" }, [
      _c("i", { staticClass: "el-icon-time" }),
      _vm._v(" Ngày mốc:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-indigo-soft text-indigo" },
      [_c("i", { staticClass: "el-icon-user-solid" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-emerald-soft text-emerald" },
      [_c("i", { staticClass: "el-icon-circle-check" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-icon-wrap bg-rose-soft text-rose" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-purple-soft text-purple" },
      [_c("i", { staticClass: "el-icon-chat-dot-round" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", { staticClass: "table-card-title" }, [
      _c("i", { staticClass: "el-icon-s-order" }),
      _vm._v(" Bảng Tiến Độ Nhận Xét Chi Tiết Theo Lớp\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }